import { NODE_RSA_CONFIG } from '@/constants/config';
import CryptoJS from 'crypto-js';
import NodeRSA from 'node-rsa';

// Use node-rsa package
export const rsaCrypto = () => {
    const nodeRSA = new NodeRSA(NODE_RSA_CONFIG.BITS);
    nodeRSA.setOptions({
        encryptionScheme: NODE_RSA_CONFIG.OPTION_ENCRYPTION_SCHEME,
        environment: NODE_RSA_CONFIG.OPTION_ENVIRONMENT,
    });
    nodeRSA.importKey(
        window.atob(process.env.VUE_APP_ENCRYPT_PUBLISHABLE_KEY),
        NODE_RSA_CONFIG.IMPORT_KEY_FORMAT
    );
    return {
        getEncryptedValue(inputVal) {
            return nodeRSA.encrypt(
                inputVal,
                NODE_RSA_CONFIG.ENCRYPT_ENCODING,
                NODE_RSA_CONFIG.ENCRYPT_SOURCE_ENCODING
            );
        },
        encryptObject(bodyData = {}) {
            const objStr = JSON.stringify(bodyData);
            return this.getEncryptedValue(objStr);
        },
    };
};

// Use crypto-js package
export const jsCrypto = (options) => {
    return {
        getDecryptedValue(encryptedVal) {
            const decryptedVal = CryptoJS.AES.decrypt(
                encryptedVal,
                options.secretKey
            );
            return JSON.parse(decryptedVal.toString(CryptoJS.enc.Utf8));
        },
    };
};
